import { Injectable } from '@angular/core';

import { Factory } from './factory.interface';
import { Investor, InvestorAddress, InvestorFiscalData, InvestorBankData } from '../Classes';
import {
    Investor as InvestorT
} from '../Interfaces';
import { UnitFactory } from './unit-factory';
// Unit Factory dependencies
import { ParkingSpaceFactory } from './parking-space-factory';
import { WarehouseFactory } from './warehouse-factory';
import { UnitPhotoFactory } from './unit-photo-factory';

@Injectable()
export class InvestorFactory implements Factory {
    constructor(
        private uf: UnitFactory
    ) { }
    createInstance(json?: (InvestorT | any)): Investor {
        let units = this.uf.createInstances((json.units) ? json.units : []); //units
        let address = new InvestorAddress(json.address); // notification address
        let fiscalAddress = new InvestorFiscalData(json.fiscal_address); // fiscal addresss
        let investorBankData = new InvestorBankData(json.bank_data); // bank data
        return new Investor(json,
            units,
            address,
            fiscalAddress,
            investorBankData
        );
    }
    createInstances(jsons: (InvestorT | any)[]): Investor[] {
        let instances: Investor[] = [];
        jsons.forEach(json => {
            instances.push(this.createInstance(json));
        });
        return instances;
    }
    deps() {
        return ['UnitFactory'];
    }
}
export const InvestorFactoryProviders =
    [
        ParkingSpaceFactory, WarehouseFactory, UnitPhotoFactory,
        {
            provide: UnitFactory, useClass: UnitFactory,
            deps: ParkingSpaceFactory, WarehouseFactory, UnitPhotoFactory
        },
        {
            provide: InvestorFactory, useClass: InvestorFactory,
            deps: [UnitFactory]
        }
    ];

export const InvestorFactoryDeps = [
    UnitFactory
];



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_models/Factories/investor-factory.ts